<app-table-toolbar color="accent" class="toolbar select-res-toolbar">
    <app-table-filter
        [filtersTogglesInOnBtn]="true"
        [cacheScope]="AppScope.POST"
        [inGlobalFilter]="true"
        color="accent"
        #filter
    >
        <app-table-search [inGlobalFilter]="true" class="align-space" searchFilterRef></app-table-search>
        <app-tag-chip-search-filter
            [inGlobalFilter]="true"
            [languageChange]="langFilter.filterChange"
            fxFlex="50%"
            fxFlex.lt-md="100%"
            fxLayoutAlign="start"
            tagsFilterRef
        ></app-tag-chip-search-filter>

        <app-table-date-filter [inGlobalFilter]="true" color="accent" dateFilterRef></app-table-date-filter>

        <app-language-filter
            [inGlobalFilter]="true"
            #langFilter
            fxFlex="0 0 auto"
            fxLayout="row"
            [prefLangIds]="prefLangIds"
            langFilterRef
        ></app-language-filter>

        <app-customer-filter
            *ngIf="isMasterAdmin$ | async"
            [inGlobalFilter]="true"
            class="customer-select"
            fxFlex="1 1 auto"
            customerSearchRef
        ></app-customer-filter>

        <app-select-filter
            [inGlobalFilter]="true"
            class="filter-space"
            label="Filter by selection"
            i18n-label="@@filterBySelection"
            [property]="GlobalFilterProperty.SELECTED"
            [options]="itemSelectedOptions"
            selectedItemsRef
        >
        </app-select-filter>
    </app-table-filter>
    <mat-progress-bar
        class="progress progress-table-loader"
        *ngIf="(dataSource.status | async) === 'loading'"
        mode="indeterminate"
    >
    </mat-progress-bar>
</app-table-toolbar>
<div fxLayoutAlign="start center" fxLayoutGap="10px" class="selection-Info">
    <div fxLayoutAlign="start center" fxLayoutGap="5px" class="main">
        <span class="label" i18n="@@numberOfPosts">Number of posts</span>
        <span class="total">{{ total }}</span>
    </div>
    <div fxLayoutAlign="start center" fxLayoutGap="5px" class="selected" *ngIf="selected">
        <span i18n="@@selected">Selected:</span>&nbsp;
        {{ selected }}
    </div>
</div>
<mat-table #table [dataSource]="dataSource" matSort [matSortActive]="defaultSorting">
    <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef>
            <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="masterToggle()"
                [checked]="isChecked()"
                [indeterminate]="isIndeterminate()"
            >
            </mat-checkbox>
        </mat-header-cell>
        <mat-cell *matCellDef="let post">
            <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="selectToggle(post)"
                [checked]="modelChecked(post)"
            >
            </mat-checkbox>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="title">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@title"> Title </mat-header-cell>
        <mat-cell *matCellDef="let post">
            <span class="mobile-label" i18n="@@title"> Title </span>
            {{ post.title }}
        </mat-cell>
    </ng-container>

    <!-- Created by -->
    <ng-container matColumnDef="created_by">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@createdBy"> Created by </mat-header-cell>

        <mat-cell *matCellDef="let post">
            <span class="mobile-label" i18n="@@createdBy"> Created by </span>
            {{ $any(post.author$ | async)?.name }}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="created_at">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@createdAt"> Created at </mat-header-cell>
        <mat-cell *matCellDef="let post">
            <span class="mobile-label" i18n="@@createdAt"> Created at </span>
            {{ post.created_at | kdDateFormat : 'YYYY-MM-DD' }}
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@status"> Status </mat-header-cell>

        <mat-cell *matCellDef="let post">
            <span class="mobile-label" i18n="@@createdBy"> Status </span>
            <div class="public-state" fxLayoutAlign="start center" fxLayoutGap="5px">
                <mat-icon *ngIf="post.public" matTooltip="Public">public</mat-icon>
                <span *ngIf="post.public" i18n="@@public">Public</span>
            </div>
            <div class="cluster-state" fxLayoutAlign="start center" fxLayoutGap="5px">
                <mat-icon *ngIf="!post.public" matTooltip="Cluster">hive</mat-icon>
                <span *ngIf="!post.public" i18n="@@cluster">Cluster</span>
            </div>
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="updated_at">
        <mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@lastEdit"> Last edit </mat-header-cell>
        <mat-cell *matCellDef="let post">
            <span class="mobile-label" i18n="@@lastEdit"> Last edit </span>
            <span [matTooltip]="'Created at: ' + (post.created_at | kdDateFormat : 'YYYY-MM-DD HH:mm')">{{
                post.updated_at | kdDateFormat : 'YYYY-MM-DD'
            }}</span>
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="academy_name">
        <mat-header-cell *matHeaderCellDef i18n="@@academy"> Academy </mat-header-cell>
        <mat-cell *matCellDef="let post">
            <span class="mobile-label" i18n="@@academy"> Academy </span>
            <span [ngClass]="{ orange: post.public, cluster: !post.public }" *ngIf="post.academy?.name">{{
                post.academy?.name
            }}</span>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="tools">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let post">
            <ng-container *ngTemplateOutlet="tools; context: { $implicit: post }"></ng-container>
        </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
    <mat-row *matRowDef="let post; columns: columns" (click)="selectToggle(post)"></mat-row>
</mat-table>

<mat-paginator class="res-select-pag" [pageSize]="25" [pageSizeOptions]="[25, 50, 100]"> </mat-paginator>
